import Vue from 'vue'
import VueRouter from 'vue-router'
import IndexHome from '../views/index/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: IndexHome
  }
]

const router = new VueRouter({
  routes
})

export default router
